import { Grid } from "@material-ui/core";
import React from "react";
import { useWatch } from "react-hook-form";

import {
  getCityOptions,
  getCountryOptions,
  getRegionOptions,
  isPhilippines,
} from "../PRPCM/locationOptions";
import { SelectFormAddress, TextForm } from "./shortKYC/fieldAndimage";

const requiredRule = { required: "This field is required" };
const zipRules = {
  required: "This field is required",
  validate: (value) => value.length === 4 || "Please input correct Zip Code",
};
const defaultInputProps = { style: { padding: "12px" } };

const AddressFields = ({
  title,
  address,
  names,
  control,
  error,
  trigger,
  setValue,
  classes,
  disabled = false,
  wrapperClassName = "mx-0 lg:mx-5 py-0 lg:py-5 border-solid border-2 px-10 pb-3",
  labels = {},
  placeholders = {},
}) => {
  const watchedCountry = useWatch({ control, name: names.country });
  const watchedRegion = useWatch({ control, name: names.region });
  const countryValue =
    watchedCountry === undefined ? address.country : watchedCountry;
  const regionValue = watchedRegion === undefined ? address.province : watchedRegion;
  const countryOptions = getCountryOptions();
  const regionOptions = getRegionOptions(countryValue);
  const cityOptions = getCityOptions(countryValue, regionValue);
  const hasRegionOptions = regionOptions.length > 0;
  const hasCityOptions = cityOptions.length > 0;
  const useCityDropdown = isPhilippines(countryValue) || hasCityOptions;
  const fieldDisabled = disabled || !countryValue;
  const cityDisabled =
    fieldDisabled || (hasRegionOptions && !regionValue) || !hasCityOptions;
  const cityTextDisabled = fieldDisabled || (hasRegionOptions && !regionValue);

  const clearAfterCountryChange = () => {
    setValue(names.region, "");
    setValue(names.city, "");

    if (names.zip) {
      setValue(names.zip, "");
    }
  };

  const clearAfterRegionChange = () => {
    setValue(names.city, "");
  };

  return (
    <div className={wrapperClassName}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <h1 className="text-center">{title}</h1>
        </Grid>
        <Grid item xs={12} lg={4} className={classes.margin}>
          <label className="dark-label-short">{labels.country || "Country"}</label>
          <SelectFormAddress
            disabled={disabled}
            trigger={trigger}
            error={error}
            control={control}
            rules={requiredRule}
            inputProps={defaultInputProps}
            placeholder={placeholders.country || "Select Country"}
            name={names.country}
            value={address.country || ""}
            className={classes.drop}
            options={countryOptions}
            onChangeExtra={clearAfterCountryChange}
          />
        </Grid>
        <Grid item xs={12} lg={4} className={classes.margin}>
          <label className="dark-label-short">
            {labels.region || "Province or Equivalent"}
          </label>
          {hasRegionOptions ? (
            <SelectFormAddress
              disabled={fieldDisabled}
              trigger={trigger}
              error={error}
              control={control}
              rules={requiredRule}
              inputProps={defaultInputProps}
              placeholder={placeholders.region || "Select Province"}
              name={names.region}
              value={address.province || ""}
              className={classes.drop}
              options={regionOptions}
              onChangeExtra={clearAfterRegionChange}
            />
          ) : (
            <TextForm
              disabled={fieldDisabled}
              trigger={trigger}
              error={error}
              control={control}
              placeholder={placeholders.regionText || "Input your province"}
              name={names.region}
              rules={requiredRule}
              inputProps={defaultInputProps}
              type="text"
              className={classes.margin}
              value={address.province}
            />
          )}
        </Grid>
        <Grid item xs={12} lg={4} className={classes.margin}>
          <label className="dark-label-short">
            {labels.city || "City, Municipality or Equivalent"}
          </label>
          {useCityDropdown ? (
            <SelectFormAddress
              disabled={cityDisabled}
              trigger={trigger}
              error={error}
              control={control}
              rules={requiredRule}
              inputProps={defaultInputProps}
              placeholder={placeholders.city || "Select City or Municipality"}
              name={names.city}
              value={address.city || ""}
              className={classes.drop}
              options={cityOptions}
            />
          ) : (
            <TextForm
              disabled={cityTextDisabled}
              trigger={trigger}
              error={error}
              control={control}
              placeholder={placeholders.cityText || "Input your city"}
              name={names.city}
              rules={requiredRule}
              inputProps={defaultInputProps}
              type="text"
              className={classes.margin}
              value={address.city}
            />
          )}
        </Grid>
        <Grid item xs={12} lg={4} className={classes.margin}>
          <label className="dark-label-short">
            {labels.barangay || "Barangay/Subdivision"}
          </label>
          <TextForm
            disabled={fieldDisabled}
            trigger={trigger}
            error={error}
            control={control}
            placeholder={placeholders.barangay || "Input your Barangay/Subdivision"}
            name={names.barangay}
            rules={requiredRule}
            inputProps={defaultInputProps}
            type="text"
            className={classes.margin}
            value={address.barangay}
          />
        </Grid>
        <Grid item xs={12} lg={4} className={classes.margin}>
          <label className="dark-label-short">
            {labels.street || "Unit#/Building Name and House#/Street Name"}
          </label>
          <TextForm
            disabled={fieldDisabled}
            trigger={trigger}
            error={error}
            control={control}
            placeholder={
              placeholders.street ||
              "Input your Unit#/Building Name and House#/Street Name"
            }
            name={names.street}
            rules={requiredRule}
            inputProps={defaultInputProps}
            type="text"
            className={classes.margin}
            value={address.street}
          />
        </Grid>
        {names.zip && isPhilippines(countryValue) && (
          <Grid item xs={12} lg={4} className={classes.margin}>
            <label className="dark-label-short">{labels.zip || "ZIP Code"}</label>
            <TextForm
              disabled={fieldDisabled}
              trigger={trigger}
              error={error}
              control={control}
              placeholder={placeholders.zip || "Input zip code"}
              name={names.zip}
              rules={zipRules}
              inputProps={defaultInputProps}
              type="number"
              className={classes.margin}
              value={address.zip}
            />
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default AddressFields;
